/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-bootstrap/tooltip/tooltip-container.component';
import * as import2 from 'ngx-bootstrap/tooltip/tooltip.config';
const styles_TooltipContainerComponent:any[] = ['.tooltip[_nghost-%COMP%] {\n      display: block;\n    }\n    .bs-tooltip-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: calc(50% - 2.5px);\n    }\n    .bs-tooltip-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: calc(50% - 2.5px);\n    }'];
export const RenderType_TooltipContainerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 0,
  styles: styles_TooltipContainerComponent,
  data: {}
}
);
export function View_TooltipContainerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'tooltip-arrow arrow'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'tooltip-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_TooltipContainerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'bs-tooltip-container',[[
        'role',
        'tooltip'
      ]
    ],[
      [
        8,
        'className',
        0
      ]
      ,
      [
        2,
        'show',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),View_TooltipContainerComponent_0,RenderType_TooltipContainerComponent)),
    import0.ɵdid(2121728,(null as any),0,import1.TooltipContainerComponent,[import2.TooltipConfig],(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (((((((('tooltip in tooltip-' + import0.ɵnov(v,1).placement) + ' ') + 'bs-tooltip-') + import0.ɵnov(v,1).placement) + ' ') + import0.ɵnov(v,1).placement) + ' ') + import0.ɵnov(v,1).containerClass);
    const currVal_1:boolean = !import0.ɵnov(v,1).isBs3;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export const TooltipContainerComponentNgFactory:import0.ComponentFactory<import1.TooltipContainerComponent> = import0.ɵccf('bs-tooltip-container',import1.TooltipContainerComponent,View_TooltipContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC90b29sdGlwL3Rvb2x0aXAtY29udGFpbmVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvdG9vbHRpcC90b29sdGlwLWNvbnRhaW5lci5jb21wb25lbnQuZC50cyIsIm5nOi8vL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC90b29sdGlwL3Rvb2x0aXAtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLlRvb2x0aXBDb250YWluZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC90b29sdGlwL3Rvb2x0aXAtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLlRvb2x0aXBDb250YWluZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2IGNsYXNzPVwidG9vbHRpcC1hcnJvdyBhcnJvd1wiPjwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJ0b29sdGlwLWlubmVyXCI+PG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PjwvZGl2PlxuICAgICIsIjxicy10b29sdGlwLWNvbnRhaW5lcj48L2JzLXRvb2x0aXAtY29udGFpbmVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7TUFDSTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXVDO01BQ3ZDO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQTJCO0lBQStCOzs7Ozs7TUNGOUQ7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7SUFBQTtJQUFBO0lBQUEsU0FBQSxtQkFBQTs7OyJ9



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/ngx-bootstrap/tooltip/tooltip-container.component.ngfactory.ts